import type {
  AppointmentPostalAddress,
  ContactOrderPostalSelection,
  ContactOrderPlanningPreview,
} from "../../../../../../../../api/kehrblatt/contact-orders"
import {
  buildAnnouncementTimingPresentation,
  postalSelectionValue,
} from "../../../../../_logic/channels"

export const postalTimingPresentation = ({
  selection,
  preview,
  active,
  pending,
  previewError,
  unavailableReason,
}: {
  selection: ContactOrderPostalSelection
  preview?: ContactOrderPlanningPreview | null
  active: boolean
  pending: boolean
  previewError?: string | null
  unavailableReason?: string | null
}) =>
  buildAnnouncementTimingPresentation({
    label: selection.mode === "NOTICE" ? "Aushang" : "Brief",
    action:
      selection.dispatch_mode === "AUTOMATIC" ? "automatisch beauftragen ab" : "Inbox-Aufgabe ab",
    active,
    pending,
    planned: Boolean(
      !unavailableReason &&
      preview?.postal_due_at &&
      postalSelectionValue(preview.postal_selection) === postalSelectionValue(selection),
    ),
    dueAt: preview?.postal_due_at,
    previewError,
  })

export const postalRecipientPresentation = (
  selection: ContactOrderPostalSelection,
  preview?: ContactOrderPlanningPreview | null,
) => {
  if (selection.manual_recipient) return selection.manual_recipient

  const option = preview?.postal_options?.find(
    (option) =>
      option.mode === selection.mode &&
      (selection.mode !== "PERSONAL" ||
        (option.customer_id === selection.customer_id &&
          (!selection.address_source ||
            (option.address_source === selection.address_source &&
              option.contact_point_id === selection.contact_point_id)))),
  )
  const sameChoice =
    preview && postalSelectionValue(preview.postal_selection) === postalSelectionValue(selection)

  return {
    name:
      selection.recipient_name ??
      option?.recipient_name ??
      (sameChoice ? preview.postal_recipient_name : null) ??
      "",
    address:
      option?.recipient_address ?? (sameChoice ? preview.postal_recipient_address : null) ?? null,
  }
}

export const postalAddressLines = (address?: AppointmentPostalAddress | null) =>
  address
    ? [
        `${address.street} ${address.house_number}`,
        address.address_extra,
        `${address.zip} ${address.city}`,
        address.country,
      ].filter(Boolean)
    : []
